import { authRoutes } from "./landing-routes";

export default (router: any) => {
  authRoutes.forEach((route: any) => {
    router.addRoute(route);
  });
};
